import { isProvisionalIdentifier } from '../../util';

class DocumentThumbnailController {
  constructor($http, $window, APIService, DocumentService, LogService) {
    "ngInject";
    this.$http = $http;
    this.$window = $window;
    this.APIService = APIService;
    this.DocumentService = DocumentService;
    this.LogService = LogService;
    this._blobSourceURL = null;
    this._blobURL = null;
    this._constructed = true;
  }

  $onInit() {
  }

  $onDestroy() {
    // Drops any response still in flight, which would otherwise create a URL nothing revokes.
    this._blobSourceURL = null;
    this._revokeBlobURL();
  }

  set document(document) {
    this._document = document;
  }

  get document() {
    return this._document;
  }

  set maxsize(maxsize) {
    this._maxsize = maxsize;
  }

  get maxsize() {
    return this._maxsize;
  }

  get useFileDataURL() {
    return !!this.fileDataURL;
  }

  get useThumbnailURL() {
    return this.document
      && !this.useFileDataURL
      && !!this.thumbnailURL;
  }

  get fileDataURL() {
    return this.document && this.document.fileDataURL;
  }

  get thumbnailURL() {
    let url = null;
    if (this.document && this.document.id && !isProvisionalIdentifier(this.document.id)) {
      if (!this.DocumentService) {
        this.LogService.error("Attempting to show thumbnail URL when DocumentService has not been created");
      } else {
        let opts;
        if (this.maxsize) {
          opts = { maxsize: this.maxsize };
        }
        url = this.DocumentService.documentThumbnailURLForDocumentId(this.document.id, opts);
      }
    }
    if (url && this.APIService.haveApplicationCredentials) {
      return this._applicationThumbnailURL(url);
    }
    return url;
  }

  /**
   * An applicant's only credential is the onboarding capability, sent as a header that an
   * <img src> request cannot carry and that must never go in a query string. So the image is
   * fetched through $http, which sends it, and shown from an object URL.
   */
  _applicationThumbnailURL(url) {
    if (this._blobSourceURL !== url) {
      this._blobSourceURL = url;
      this._revokeBlobURL();
      this.$http.get(url, { responseType: 'blob' })
        .then(response => {
          // The document may have changed while this was in flight.
          if (this._blobSourceURL !== url) {
            return;
          }
          // A login or error page answered with 200 is not an image.
          const type = response.data && response.data.type;
          if (!type || !type.startsWith('image/')) {
            this.LogService.warn("Document thumbnail response was not an image", type);
            return;
          }
          // Two requests for the same URL can both land; release the first one's blob.
          this._revokeBlobURL();
          this._blobURL = this.$window.URL.createObjectURL(response.data);
        })
        .catch(error => {
          this.LogService.warn("Unable to load document thumbnail", error && error.status);
        });
    }
    return this._blobURL;
  }

  _revokeBlobURL() {
    if (this._blobURL) {
      this.$window.URL.revokeObjectURL(this._blobURL);
      this._blobURL = null;
    }
  }

  get altText() {
    if(this.document){
      return this.document.title ?? this.document.name ?? this.document.id;
    }
  }
}

export default DocumentThumbnailController;
